export default __webpack_public_path__ + "static/before-8a3cbc1d34e58a8aaa2d88ace6a5cf3c.png";